export default (theme) => ({
  github__svg: {
    height: 30,
    width: 30,
    '&:hover': {
      filter: 'hue-rotate(10deg)',
    },
  },
});
